
import { db } from '../firebase';
import { 
    doc, 
    updateDoc, 
    collection, 
    query, 
    where, 
    documentId,
    onSnapshot 
} from 'firebase/firestore';
import { Organization } from '../types';
import { FirestoreUtils } from './FirestoreUtils';

export const OrganizationService = {
    /**
     * Updates an organization document.
     */
    async updateOrganization(orgId: string, data: Partial<Organization>) {
        const orgRef = doc(db, 'organizations', orgId);
        await updateDoc(orgRef, {
            ...data,
            updatedAt: Date.now()
        });
    },

    /**
     * Subscribes to a specific organization.
     */
    listenToOrganization(orgId: string, callback: (org: Organization | null) => void) {
        return onSnapshot(doc(db, 'organizations', orgId), (snap) => {
            if (snap.exists()) {
                callback({ id: snap.id, ...snap.data() } as Organization);
            } else {
                callback(null);
            }
        });
    },

    /**
     * Subscribes to a list of organizations by IDs.
     * Refactored: Uses chunking to support belonging to > 30 organizations.
     */
    listenToOrganizations(orgIds: string[], callback: (orgs: Organization[]) => void) {
        if (!orgIds || orgIds.length === 0) {
            callback([]);
            return () => {};
        }
        
        const baseQuery = collection(db, 'organizations');
        return FirestoreUtils.onSnapshotChunked(baseQuery, documentId(), orgIds, (results) => {
            callback(results as Organization[]);
        });
    },

    /**
     * Updates the user's current organization focus.
     */
    async switchOrganization(userId: string, orgId: string) {
        const userRef = doc(db, 'users', userId);
        await updateDoc(userRef, { orgId });
    }
};
